import React, { useState, createContext, useEffect } from "react";
import cookie from "js-cookie";
import { useNavigate, useRoutes } from "react-router-dom";
export const Context = createContext();

function ContextApi({ children }) {
  const [value, setValue] = useState("");
  const navigate = useNavigate();
  let elements;

  useEffect(() => {
    if (
      cookie.get("token") === null ||
      cookie.get("token") === "" ||
      cookie.get("token") === undefined
    ) {
      // router.push({ pathname: "/Login" });

      navigate("/login");
    } else {
      if (cookie.get("role") === "reception") {
        navigate("/billing");
      }
      if (cookie.get("role") === "user") {
        navigate("/PageNotFound");
      }
    }

    // setValue(cookie.get("role"));
  }, [cookie]);
  console.log(value);
  return (
    <div>
      <Context.Provider value={{ value }}>{children}</Context.Provider>
    </div>
  );
}

export default ContextApi;
